// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_STATUT_ENTREPRENEURS,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getStatutEntrepreneurs = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('statut_entrepreneurs')
      .then(
        (response) => {
          dispatch(GET_STATUT_ENTREPRENEURS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/statutEntrepreneursActions.js